// extracted by mini-css-extract-plugin
export default {"main":"OrderSummary_main__KO1oF","row":"OrderSummary_row__RWs-h","finalRow":"OrderSummary_finalRow__oxdvF","footnote":"OrderSummary_footnote__IyYK0"};